import { Switch } from '@trackman/web-shared-components';

export const MembershipRequired = ({
  isPremiumEvent,
  setPremiumEvent,
}: {
  isPremiumEvent: boolean;
  setPremiumEvent: (value: boolean) => void;
}) => {
  return (
    <div className='admin-edit-section'>
      <h2>Restrictions</h2>
      <Switch
        label='Premium required'
        hint='Only users with Premium subscription will be able to attend this Event.'
        onChange={() => setPremiumEvent(!isPremiumEvent)}
        checked={isPremiumEvent}
      />
    </div>
  );
};
